import { Mail, Phone } from 'lucide-react'

const contact = {
  emails: ['contact@ritikmedicare.in', 'ritikmedicare@gmail.com'],
  phone: '+91 7996337555',
}

export default function TopContactBar() {
  return (
    <div className="hidden sm:block bg-brand-primary text-white">
      <div className="mx-auto max-w-7xl px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-3 text-sm">
          {contact.emails.slice(0,1).map((email) => (
            <a
              key={email}
              href={`mailto:${email}`}
              className="inline-flex items-center gap-2 hover:opacity-90"
            >
              <Mail size={16} />
              <span>{email}</span>
            </a>
          ))}
          <span className="opacity-60">|</span>
          <a href={`tel:${contact.phone}`} className="inline-flex items-center gap-2 hover:opacity-90">
            <Phone size={16} />
            <span>{contact.phone}</span>
          </a>
        </div>
        {/* <div className="text-sm opacity-90 truncate max-w-[420px]">
          Kamakunj, Pali Hill No. 3, Near Water Tank 1-G, Tithal Road, Bhagadawada, Taluka - Valsad, Valsad, Gujarat, India - 396001
        </div> */}
      </div>
    </div>
  )
}

